import { render, staticRenderFns } from "./AutoRewardsBasket.vue?vue&type=template&id=3564b9aa"
import script from "./AutoRewardsBasket.vue?vue&type=script&lang=js"
export * from "./AutoRewardsBasket.vue?vue&type=script&lang=js"
import style0 from "./AutoRewardsBasket.vue?vue&type=style&index=0&id=3564b9aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports